export const state = {
  applicants: [],
  recruiters: [],
  contracts: [],
  invoices: [],
  billing_plan:null,
  billing_plans:[]
}
